import * as React from 'react';
import { Icon } from 'kui';
import { HELP_PANEL_LINKS_FAQ, } from '../../constants';
import { IHelpPanelAffiliateLinkProps } from './types';

export const HelpPanelFAQComponent = ({
    onClick
}: IHelpPanelAffiliateLinkProps) => {
    return (
        <span className={'help-panel__link'}>
            <a href={'http://www.kanbanchi.com/kanbanchi-faq'} target="_blank" onClick={onClick}>
            <Icon xlink="help" size={24} />
                {HELP_PANEL_LINKS_FAQ}
            </a>
        </span>
    );
};
